<!--P008、P009-->
<template>
  <div class="div_content">
    <div class="cs_margin_top_sm ui_hierarchy">
      <div class="cs_cursor_pointer ui_txt_hierarchy" @click="$router.push({name:'SupplierManage'})">供应商维护</div>
      <div class="ui_txt_hierarchy">&nbsp;>&nbsp;</div>
      <div class="cs_font_bold cs_cursor_pointer ui_txt_hierarchy">供应商详情</div>
    </div>
    <!--基本信息-->
    <div class="cs_margin_top ui_divider_title">
      <div class="divider_title_info"></div>
      <div class="title_info">基本信息</div>
    </div>
    <div class="cs_margin_top div_search">
      <div class="cs_title_primary cs_text_default type_info_search">供应商编号</div>
      <div class="cs_radius_lg txt_info_search">{{search.supplierNum}}</div>
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_left">供应商名称</div>
      <input v-model="search.supplierName" @input="transformCnChar" class="cs_input cs_radius_lg edtxt_info_search width_280" placeholder="请输入">
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_left">拼音码</div>
      <input v-model="search.spellCode" class="cs_input cs_radius_lg edtxt_info_search ui_margin_left_30" placeholder="请输入">
      <br>
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_top_sm">联系人</div>
      <input v-model="search.contactName" class="cs_input cs_radius_lg edtxt_info_search cs_margin_top_sm ui_margin_left_44" placeholder="非必填">
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_left cs_margin_top_sm">联系方式</div>
      <input v-model="search.mobileNo" class="cs_input cs_radius_lg edtxt_info_search cs_margin_top_sm ui_margin_left_30 width_280" placeholder="非必填">
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_top_sm cs_margin_left">启用状态</div>
      <div class="cs_radius_lg txt_info_search cs_margin_top_sm">{{SUPPLIER_STATUS[search.isStop]}}</div>
      <button @click="btnSave" class="cs_btn cs_btn_sm ui_btn_blue cs_margin_top_sm cs_fr"
              type="button">保存
      </button>
      <br>
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_top_sm">在途天数</div>
      <input v-model="search.transitDay" @keyup="checkNonNegativeInt($event)" @blur="search.transitDay=checkNonNegativeIntBlur($event)" class="cs_input cs_radius_lg edtxt_info_search cs_margin_top_sm ui_margin_left_30" placeholder="请输入">
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_left cs_margin_top_sm">月采购频次</div>
      <input v-model="search.purchaseFrequency" @keyup="checkPositiveInt($event)" @blur="search.purchaseFrequency=checkPositiveInt($event)" class="cs_input cs_radius_lg edtxt_info_search cs_margin_top_sm width_280" placeholder="请输入">
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_top_sm cs_margin_left">结算类型</div>
      <web-select :options="SETTLE_TYPE"
                  @option-key="updateType"
                  v-model="search.typeName"
                  class="cs_input cs_radius_lg edtxt_info_search cs_margin_top_sm"></web-select>
    </div>
    <!--货品管理-->
    <div class="cs_margin_top_xl ui_divider_title">
      <div class="divider_title_info"></div>
      <div class="title_info">货品管理</div>
    </div>
    <div class="cs_margin_top div_search_result cs_padding_top">
      <div class="div_operation_table">
        <button @click="btnAdd" class="cs_btn cs_btn_sm ui_btn_blue cs_fr cs_margin_left_sm"
                type="button">添加
        </button>
        <button @click="btnDelete" class="cs_btn cs_btn_sm ui_btn_ghost_blue cs_fr"
                type="button">删除
        </button>
      </div>
      <div class="cs_margin_top div_table">
        <table class="cs_table cs_td_divider_none cs_thead_fixed" width="100%">
          <thead>
          <tr>
            <th width="40px">序号</th>
            <th width="151px">货品编号</th>
            <th width="280px">货品名称</th>
            <th width="100px">规格</th>
            <th width="174px">采购单位</th>
            <th width="174px">采购单价</th>
            <th width="100%">货品启用状态</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item,index) in orderList" :class="{ 'cs_tr_selected': item.isSelected}" @click="btnSelectTableTr(item)">
            <td width="40px">{{index+1}}</td>
            <td width="151px">{{item.materialNum}}</td>
            <td width="280px">{{item.materialName}}</td>
            <td width="100px">{{item.materialSpecs}}</td>
            <td width="174px">{{item.units}}</td>
            <td width="174px">{{item.unitPrice}}</td>
            <td width="100%">{{SUPPLIER_STATUS[item.isStop]}}</td>
          </tr>
          <template v-if="PAGE_SIZE>orderList.length">
            <tr v-for="(item,index) in (PAGE_SIZE-orderList.length)">
              <td width="40px"></td>
              <td width="151px"></td>
              <td width="280px"></td>
              <td width="100px"></td>
              <td width="174px"></td>
              <td width="174px"></td>
              <td width="100%"></td>
            </tr>
          </template>
          </tbody>
        </table>
      </div>
      <div class="cs_text_sm cs_text_primary cs_margin_top_xs txt_hint_table">供货数量：{{orderList.length}}</div>
    </div>
    <div class="div_bottom"></div>

    <!--添加货品弹窗，默认隐藏-->
    <div v-if="isDialogMaterialShow" class="ui_div_dialog">
      <div class="ui_dialog_container" style="width:400px;height:416px;padding: 24px;">
        <div class="ui_divider_title">
          <div class="divider_title_info"></div>
          <div class="title_info">添加货品</div>
        </div>
        <div class="cs_margin_top_lg div_search">
          <div class="cs_title_primary cs_text_default type_info_search margin_left_18">货品</div>
          <search-select :options="dialogMaterial.materialSearchItems"
                         @option-key="updateMaterialName"
                         v-model="dialogMaterial.materialName"
                         :search-fn="acquireMaterialItem"
                         class="cs_input cs_radius_lg edtxt_info_search width_246 ui_margin_left_44"></search-select>
        </div>
        <div class="margin_top_12 div_search">
          <div class="cs_title_primary cs_text_default type_info_search margin_left_18">规格</div>
          <div class="cs_radius_lg txt_info_search width_246 ui_margin_left_44">{{dialogMaterial.materialSpecs}}</div>
        </div>
        <div class="margin_top_12 div_search">
          <div class="cs_title_primary cs_text_default type_info_search margin_left_18">采购单位</div>
          <div class="cs_radius_lg txt_info_search width_246">{{dialogMaterial.purchaseUnit}}</div>
        </div>
        <div class="margin_top_12 div_search">
          <div class="cs_title_primary cs_text_default type_info_search margin_left_18">采购单价</div>
          <input v-model="priceDialog" class="cs_input cs_radius_lg edtxt_info_search width_246" @keyup="inputLimitPositiveFloat($event)" @blur="priceDialog=formatPositiveFloat($event)">
        </div>
        <div class="cs_margin_top_sm cs_text_sm txt_hint_dialog cs_align_center">{{dialogMaterial.hintDialog}}</div>
        <!--确定取消按钮-->
        <div class="cs_margin_top_lg div_search cs_align_center">
          <button type="button" class="cs_btn ui_btn_ghost_blue" @click="closeDialog">取消</button>
          <button type="button" class="cs_btn ui_btn_blue ui_margin_left_88" @click="btnConfirmDialog">确定</button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import WebSelect from "../../components/web-select"
  import SearchSelect from "../../components/search-select"
  import WhParameter from "../../assets/csui/parameter/WhParameter"
  import {Page, PAGE_SIZE,SUPPLIER_STATUS,SETTLE_TYPE} from "../../assets/utils/constants"
  export default {
    name: "SupplierDetail",
    components: {WebSelect,SearchSelect},
    data: function () {
      return {
        search: {
          supplierNum: "",
          supplierName: "",
          transitDay:"",
          purchaseFrequency:"",
          contactName: "",
          mobileNo: "",
          spellCode: "",
          isStop: "",
          typeId:0,
          typeName:"",
          pageJump: "",
          totalPage: "",
          pagination: 1
        },
        orderList: [],
        selectedId: "",
        isDialogMaterialShow: false,
        dialogMaterial: {
          materialId: "",
          materialName: "",
          materialSearchItems: [],
          purchaseUnit: "",
          hintDialog: "",
          materialSpecs:""
        },
        priceDialog: "",
        PAGE_SIZE: PAGE_SIZE,
        SUPPLIER_STATUS: SUPPLIER_STATUS,
        SETTLE_TYPE: SETTLE_TYPE
      }
    },
    created: function () {

    },
    mounted: function() {
      this.showDetail();
    },
    methods: {
      showDetail(){
        this.$ajax.supplier.acquire.bind(this)(this.$route.query.num,(data) => {
          this.search.supplierNum = data.data.order.supplierNum;
          this.search.supplierName = data.data.order.supplierName;
          this.search.transitDay = data.data.order.transitDay;
          this.search.purchaseFrequency = data.data.order.purchaseFrequency;
          this.search.contactName = data.data.order.contactName;
          this.search.mobileNo = data.data.order.contactMobileno;
          this.search.spellCode = data.data.order.spellCode;
          this.search.isStop = data.data.order.stop;
          this.search.typeId = data.data.order.settleType;
          this.search.typeName = this.SETTLE_TYPE[data.data.order.settleType];
          let list = data.data.list;
          list.forEach((item) => {
            item.isSelected = false;
          });
          this.orderList = list;
        }, (data) => {
        }, true)
      },
      btnSave(){
        try {
          WhParameter.verifyNotEmpty(this.search.supplierName, "供应商名称");
          WhParameter.verifyNotEmpty(this.search.spellCode, "拼音码");
          WhParameter.verifyNotEmpty(this.search.transitDay, "在途天数");
          WhParameter.verifyNotEmpty(this.search.purchaseFrequency, "月采购频次");
        }catch (e) {
          this.$toast(e.message);
          return;
        }
        if(this.isEmptySelect(this.search.typeId)){
          this.$toast("请选择结算类型");
          return;
        }
        this.$ajax.supplier.modify.bind(this)(this.search,(data) => {
          this.$toast("保存成功");
        }, (data) => {
        }, true)
      },
      transformCnChar() {
        let char = this.search.supplierName;
        this.search.spellCode = pinyinUtil.getFirstLetter(char);
      },
      updateType(key) {
        this.search.typeId = key;
      },
      btnSelectTableTr(item){
        let selectedStatus = item.isSelected;
        this.orderList.forEach((item1) => {
          item1.isSelected = false;
        });
        item.isSelected = !selectedStatus;
        if(item.isSelected){
          this.selectedId = item.materialId;
        }else {
          this.selectedId = "";
        }
      },
      btnDelete(){
        if(this.isEmpty(this.selectedId)){
          this.$toast("请先选中一条数据");
          return;
        }
        this.$ajax.supplier.deleteMaterial.bind(this)(this.$route.query.id,this.selectedId, (data) => {
          this.$toast("删除成功");
          this.selectedId = "";
          this.showDetail();
        }, (data) => {
        }, true)
      },
      btnAdd(){
        this.isDialogMaterialShow = true;
      },
      btnConfirmDialog(){
        if (this.isEmpty(this.dialogMaterial.materialId)) {
          this.dialogMaterial.hintDialog = "请选择货品";
          return
        }
        if (this.isEmpty(this.priceDialog)) {
          this.dialogMaterial.hintDialog = "请输入采购单价";
          return
        }
        this.$ajax.supplier.addMaterial.bind(this)(this.$route.query.id,this.dialogMaterial.materialId,this.priceDialog, (data) => {
          this.$toast("添加成功");
          this.showDetail();
          this.closeDialog();
        }, (data) => {
        }, true,this.showErrorMsg)
      },
      closeDialog(){
        this.isDialogMaterialShow = false;
        this.dialogMaterial = {
          materialId: "",
          materialName: "",
          materialSearchItems: [],
          purchaseUnit: "",
          hintDialog: "",
          materialSpecs:""
        };
        this.priceDialog = "";
      },
      acquireMaterialItem(search) {
        this.$ajax.common.searchMaterial.bind(this)(search, (data) => {
          let array = [];
          for (let i = 0; i < data.data.length; i++) {
            array.push({
              key: data.data[i].id,
              value: data.data[i].materialNum + "  " + data.data[i].materialName,
              purchaseUnit: data.data[i].purchaseUnit,
              materialSpecs: data.data[i].materialSpecs,
            })
          }
          this.dialogMaterial.materialSearchItems = array;
        }, this.failDefault, false);
      },
      updateMaterialName(key) {
        this.dialogMaterial.materialId = key;
        if(!this.isEmpty(key)){
          for(let i=0;i<this.dialogMaterial.materialSearchItems.length;i++){
            if(this.dialogMaterial.materialSearchItems[i].key === key){
              this.dialogMaterial.purchaseUnit = this.dialogMaterial.materialSearchItems[i].purchaseUnit;
              this.dialogMaterial.materialSpecs = this.dialogMaterial.materialSearchItems[i].materialSpecs;
              return;
            }
          }
        }else {
          this.dialogMaterial.hintDialog = "";
          this.dialogMaterial.purchaseUnit = "";
          this.dialogMaterial.materialSpecs = "";
        }
      },
      showErrorMsg: function (msg) {
        this.dialogMaterial.hintDialog = msg;
      },

      failDefault() {
      },
    },
  }
</script>

<style scoped>
  .width_246{width: 246px;}
  .width_280{width: 280px;}
  .txt_hint_dialog{
    position: relative;
    width: 100%;
    height: 20px;
    line-height: 20px;
    color: #FFB54C;
    text-align: center;
  }
  .txt_hint_table{
    position: relative;
    width: 100%;
    height: 20px;
    line-height: 20px;
  }
  .margin_left_18{margin-left: 18px;}
  .margin_top_12{margin-top: 12px;}
  .cs_table tbody{max-height: 411px;}
</style>



// WEBPACK FOOTER //
// src/page/supplier/SupplierDetail.vue